import produce from "immer";
import { SectionChanges } from "../../../ConfirmUpdateModal/types";
import { State } from "../../types";

export type UpdateEditData = {
  type: "updateEditData";
  payload: { changes?: SectionChanges[]; showUpdateConfirm: boolean };
};

/**
 * Stores what the confirmation dialog needs: whether it is open, and the list
 * of changes it displays.
 *
 * This reducer does not compute anything. The diff between the saved rule and
 * the edited one is built by `getChanges` (see
 * `ConfirmUpdateModal/README.md`), which SaveButton runs before dispatching —
 * so a new property never requires touching this file, only the section config
 * in `ConfirmUpdateModal/sections.ts`.
 */
export function updateEditData(
  state: State,
  payload: UpdateEditData["payload"]
): State {
  return produce(state, draft => {
    if ("showUpdateConfirm" in payload) {
      draft.editData.showUpdateConfirm = payload.showUpdateConfirm;
    }

    if ("changes" in payload && payload.changes) {
      draft.editData.changes = payload.changes;
    }
  });
}
